import {TextProps, ThemeColorTextPath, ThemeIconKey} from 'platform/foundation';

import {Nullish, TestIdProps} from 'shared/web';

export type ParameterItem = TestIdProps & {
  title?: string | Nullish;
  icon?: ThemeIconKey;
  variant?: ThemeColorTextPath;
  size?: 'base' | 'small' | 'xSmall';
  alternative?: boolean;
  parametersProps?: TextProps;
  onClick?: (e: React.MouseEvent) => void;
  hideSeparator?: boolean;
};
